module.exports = __webpack_public_path__ + "img/u121.b1a6b409.png";